import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { RequestFormStore, RequestFormViewModel } from 'stores/requests/request-form-store';
import { nameof } from 'utils/object';
import TailwindCustomizationDataEditor from 'widgets/bussiness/customization-data-editor-tw';
import TailwindDeliveryMethodEditor from 'widgets/bussiness/delivery-method-editor-tw';
import TailwindLanguageEditor from 'widgets/bussiness/language-editor-tw';
import TailwindTrainingLevelEditor from 'widgets/bussiness/training-level-editor-tw';

interface RequestTrainingDetailsContainerProp {
  request?: RequestFormViewModel;
  readOnly: boolean;
  requestFormStore?: RequestFormStore;
  onChange?: (value: Partial<RequestFormViewModel>) => void;
}

const RequestTrainingDetailsContainer: React.FC<RequestTrainingDetailsContainerProp> = ({
  request,
  readOnly,
  requestFormStore,
  onChange
}) => {
  const { t } = useTranslation();
  const [selectedRequest /*, setSelectedRequest*/] = useState<RequestFormViewModel>(request);

  const { trainingLevel, customization, deliveryMethod, language } = selectedRequest;

  const handleOnChange = (property: string, value: any) => {
    let change = {};
    change[property] = value;
    requestFormStore.change(change);
    onChange && onChange(change);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm text-gray-700">{t('Training level')}</label>
        <TailwindTrainingLevelEditor
          placeholder={t('Training Level')}
          readOnly={readOnly}
          className="w-full border border-gray-300 p-2 rounded bg-gray-100"
          nullable
          value={trainingLevel}
          onChange={value => handleOnChange(nameof<RequestFormViewModel>('trainingLevel'), value)}
        />
      </div>
      {(customization || !readOnly) && (
        <div>
          <label className="text-sm text-gray-700">{t('Customization')}</label>
          <TailwindCustomizationDataEditor
            placeholder={t('Customization')}
            readOnly={readOnly}
            className="w-full border border-gray-300 p-2 rounded bg-gray-100"
            nullable
            value={customization}
            onChange={value => handleOnChange(nameof<RequestFormViewModel>('customization'), value)}
          />
        </div>
      )}
      <div>
        <label className="text-sm text-gray-700">{t('Delivery Method')}</label>
        <TailwindDeliveryMethodEditor
          placeholder={t('Delivery Method')}
          readOnly={readOnly}
          className="w-full border border-gray-300 p-2 rounded bg-gray-100"
          nullable
          value={deliveryMethod}
          onChange={value => handleOnChange(nameof<RequestFormViewModel>('deliveryMethod'), value)}
        />
      </div>
      {(language || !readOnly) && (
        <div>
          <label className="text-sm text-gray-700">{t('Language')}</label>
          <TailwindLanguageEditor
            placeholder={t('Delivery Method')}
            readOnly={readOnly}
            className="w-full border border-gray-300 p-2 rounded bg-gray-100"
            nullable
            value={language}
            onChange={value => handleOnChange(nameof<RequestFormViewModel>('language'), value)}
          />
        </div>
      )}
    </div>
  );
};

export default connect(['requestFormStore', RequestFormStore])(RequestTrainingDetailsContainer);
